import angular = require("angular");
import TPL = require("templates");

import {SessionService} from "../../services/session";

export class BurgerDirective {

  static currentModal;

  scope = {
    params: "=params"
  };
  template;
  link;

  constructor(session: SessionService, $modal) {
    this.template = TPL.navigationDirectives.burger;

    this.link = (scope, el, attrs)=> {
      scope.vm = {
        session: session,
        openMenuModal: () => {
          BurgerDirective.currentModal = $modal.open({
            controller: () => scope.vm,
            controllerAs: "vm",
            replace: true,
            size: "fs",
            backdropClass: "of-burger-backdrop",
            windowClass: "of-burger-window",
            template: TPL.modals.burger
          });
        },
      };
    }
  }

  static factory() {
    var tmp = (a, b) => new BurgerDirective(a, b);
    tmp.$inject = ["session", "$uibModal"];
    return tmp;
  }
}



/** WEBPACK FOOTER **
 ** ./src/scripts/directives/navigation/burger.ts
 **/